<template>
  <div class="row justify-center pt-6 pt-md-11 pb-10 pb-md-12">
    <!-- Основная форма с опросом -->
    <transition name="fade" mode="out-in">
      <div class="col-xl-6 col-lg-8 col-md-10 col-12 feedback-block" v-if="check !== 'email' && check !== 'thanks'">
        <bimTextAccent tag="h1" bold class="mb-6">Консультация экспертов</bimTextAccent>
        <bimTextMedium
          tag="p"
          class="mb-4"
        >В ближайшее время мы планируем запустить услугу прямых оперативных консультаций от аттестованных экспертов Минстроя РФ (по всем направлениям).
        </bimTextMedium>
        <bimTextMedium
          tag="p"
          class="mb-4"
        >Консультация будет проводиться по телефону после обращения через онлайн-форму с прикреплением всех необходимых документов.
        </bimTextMedium>
        <bimTextMedium tag="p" bold class="mb-4">Мы проводим опрос:</bimTextMedium>

        <bimTextMain tag="h2" bold class="mb-6">Cколько Вы готовы заплатить за одну такую профессиональную консультацию от эксперта?</bimTextMain>

        <!-- Цены -->
        <div class="row middle-xs justify-center-xs mb-10">
          <div class="col-md-4 col-12 mb-6 mb-md-0">
            <div class="how_much" @click="price(69)">
              <span class="first-item">69</span>
              <span class="second-item">рублей</span>
            </div>
          </div>
          <div class="col-md-4 col-12 mb-6 mb-md-0">
            <div class="how_much" @click="price(99)">
              <span class="first-item">99</span>
              <span class="second-item">рублей</span>
            </div>
          </div>
          <div class="col-md-4 col-12 mb-6 mb-md-0">
            <div class="how_much" @click="price(129)">
              <span class="first-item">129</span>
              <span class="second-item">рублей</span>
            </div>
          </div>
        </div>

        <!-- Отказ -->
        <span
          class="link-main link-main--border-green link-main--dashed-small"
          @click="check = 'thanks'"
        >Спасибо, мне не интересна эта услуга
        </span>
      </div>
    </transition>

    <!-- Завершающая форма с благодарностью -->
    <transition name="fade" mode="out-in">
      <div class="d-flex flex-column justify-center align-center col-md-6 col-12 text-center feedback-block" v-if="check === 'thanks'">
        <bimTextAccent bold tag="h2" class="mb-4">Благодарим вас за уделенное время.</bimTextAccent>
        <bimTextMain tag="p" class="mb-11">Спасибо, что помогаете нам стать лучше!</bimTextMain>
        <bim-button href="/" label="На главную"/>
      </div>
    </transition>

    <!-- Форма с запросом email'a -->
    <transition name="fade" mode="out-in">
      <div class="col-md-4 col-12 feedback-block d-flex flex-column justify-center" v-if="check === 'email'">
        <bimTextAccent bold tag="h2" class="mb-6">Спасибо за участие в опросе!</bimTextAccent>
        <bimTextMedium class="mb-9">Пожалуйста оставьте свой адрес электронной почты и мы уведомим вас о запуске услуги.</bimTextMedium>

        <!-- Форма е-мейла -->
        <form
          class="mb-9"
          @submit.prevent="validateBeforeSubmit(formScope)"
          :data-vv-scope="formScope"
        >
          <div class="mb-6">
            <bim-input @keyup.enter="$emit('submit')" v-model="email" type="email" name="email" placeholder="Введите ваш e-mail" data-vv-as="e-mail" v-validate="'required|email'"/>
            <bim-tooltip :value="errors.has('email', formScope)">{{ errors.first('email', formScope) }}</bim-tooltip>
          </div>

          <bim-button type="submit" label="Отправить"/>
        </form>

        <!-- Отказ -->
        <span
          class="link-main link-main--border-green link-main--dashed-small align-self-start"
          @click="skipEmail"
        >Пропустить
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import bimTextAccent from '@bimlib/components/bimTextAccent'
import bimTextMain from '@bimlib/components/bimTextMain'
import bimTextMedium from '@bimlib/components/bimTextMedium'
import bimInput from '@bimlib/components/bimInput'
import bimTooltip from '@bimlib/components/bimTooltip'

export default {
  name: 'interviewpage',
  props: {
    user: {
      type: [Array, Object],
      default: '',
    },
  },
  components: {
    bimTextAccent,
    bimTextMain,
    bimTextMedium,
    bimInput,
    bimTooltip,
  },
  mounted () {
    if (!_.isEmpty(this.user.email)) {
      this.email = this.user.email
    }
  },
  data () {
    return {
      email: '',
      formScope: 'interview',
      check: '',
      summa: '',
    }
  },
  methods: {
    price (val) {
      this.check = 'email'
      this.summa = val
    },
    skipEmail () {
      this.email = ''
      this.sendForm()
    },
    validateBeforeSubmit (scope) {
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result) {
            this.sendForm()
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    sendForm () {
      this.check = 'thanks'
      const data = new FormData()

      if (!_.isEmpty(this.user.id)) {
        data.append('id', this.user.id)
      }
      if (!_.isEmpty(this.email)) {
        data.append('email', this.email)
      }
      data.append('price', this.summa)
      axios
        .post('/experts/new/', data)
        .then(response => {
          // console.log(response);
          if (response.data.success === true) {

          } else if (response.data.success === false) {
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.feedback-block {
  min-height : 50vh;
}

.how_much {
  display         : flex;
  flex-direction  : column;
  justify-content : center;
  align-items     : center;
  width           : 100%;
  height          : 200px;
  overflow        : hidden;

  color           : $primary-color;

  border          : 2px solid $primary-color;
  border-radius   : 18px;
  cursor          : pointer;

  transition      : background-color 0.2s, color 0s;

  &:hover {
    background-color : $primary-color;
    color            : $white-color;
  }

  .first-item {
    font-size : 100px;
  }

  .second-item {
    font-size : 30px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition : 0.5s;
}

.fade-enter,
.fade-leave-to {
  position : absolute;
  left     : 200%;
}
</style>
